const projectData = [
  {
    id: 1,
    imgSrc: "/assets/image/clean/1.jpg",
    title: "Al Futtaim Contracting L.L.C",
    description:
      "Provided scheduled cleaning and pest control services for offices and common areas in a busy contracting environment, ensuring hygiene compliance near a high-traffic government district.",
  },
  {
    id: 2,
    imgSrc: "/assets/image/clean/2.jpg",
    title: "Shapoorji Pallonji Mideast L.L.C",
    description:
      "Delivered comprehensive pest control and periodic cleaning in commercial office spaces, with emphasis on eco-safe products suitable for mall environments.",
  },
  {
    id: 3,
    imgSrc: "/assets/image/clean/3.jpg",
    title: "Buhaleeba Contracting L.L.C",
    description:
      "Full floor cleaning and disinfection for corporate offices, including duct cleaning and pest treatment in technical and pantry areas.",
  },
  {
    id: 4,
    imgSrc: "/assets/image/clean/4.jpg",
    title: "Naresco Contracting L.L.C",
    description:
      "Conducted pest control and general cleaning at construction offices and site facilities, targeting labor accommodation hygiene and rodent prevention.",
  },
  {
    id: 5,
    imgSrc: "/assets/image/clean/5.jpg",
    title: "Emirates Properties L.L.C",
    description:
      "Regular cleaning of property management offices and deep cleaning of tenant turnover units, with integrated pest monitoring across assets.",
  },
  {
    id: 6,
    imgSrc: "/assets/image/clean/20.jpg",
    title: "Ideal Contracting L.L.C",
    description:
      "Industrial cleaning and localized pest treatment for construction offices and job sites, focused on seasonal pest management in the U.S. climate.",
  },
  {
    id: 7,
    imgSrc: "/assets/image/clean/7.jpg",
    title: "AL RUKN CONTRACTING L.L.C",
    description:
      "Labor camp sanitation and pest control in residential and storage buildings, with focus on cockroach and rodent control in kitchens and dormitories.",
  },
  {
    id: 8,
    imgSrc: "/assets/image/clean/8.jpg",
    title: "ASGC Construction L.L.C",
    description:
      "Post-construction cleanup and pest control for corporate office floors, including monthly pest treatment in HVAC and service areas.",
  },
  {
    id: 9,
    imgSrc: "/assets/image/clean/9.jpg",
    title: "C D F RESTAURANT L.L.C",
    description:
      "Comprehensive F&B cleaning and pest management for dining and kitchen zones, ensuring health and safety standards for restaurant operations.",
  },

  {
    id: 10,
    imgSrc: "/assets/image/clean/10.jpg",
    title: "EMIRATES PARKING L.L.C",
    description:
      "Parking lot pest control and facility cleaning for customer service areas, ticket booths, and admin offices within the parking premises.",
  },
  {
    id: 11,
    imgSrc: "/assets/image/clean/11.jpg",
    title: "La Cantine Du Faubourg L.L.C",
    description:
      "Routine kitchen deep cleaning and fly/insect pest control in a luxury dining setting, maintaining a premium hygiene environment.",
  },
  {
    id: 12,
    imgSrc: "/assets/image/clean/12.jpg",
    title: "Doris Duan young Autism Center",
    description:
      "Child-safe cleaning services and non-toxic pest control across therapy rooms and offices, strictly following healthcare facility protocols.",
  },
  {
    id: 13,
    imgSrc: "/assets/image/clean/13.jpg",
    title: "Arabtec Construction L.L.C",
    description:
      "Cleaning and pest treatment for international site offices and administrative spaces, supporting safe operations for a major construction contractor.",
  },
  {
    id: 14,
    imgSrc: "/assets/image/clean/14.jpg",
    title: "Shams Construction L.L.C",
    description:
      "General site and office sanitation services, including pest prevention during construction phases and cleaning before handover stages.",
  },
  {
    id: 15,
    imgSrc: "/assets/image/clean/15.jpg",
    title: "Gulf Fortune International L.L.C",
    description:
      "Warehouse disinfection and pest control in logistics and goods storage zones, ensuring product safety and hygiene compliance.",
  },
  {
    id: 16,
    imgSrc: "/assets/image/clean/16.jpg",
    title: "Dubai Walls Construction L.L.C",
    description:
      "Cleaning and pest control in construction zones and staff offices, including treatment of building basements and service areas.",
  },
  {
    id: 17,
    imgSrc: "/assets/image/clean/17.jpg",
    title: "Evan Lim Contruction Co L.L.C",
    description:
      "Office cleaning and pest control for high-rise commercial settings, focusing on pest entry-point sealing and regular sanitization.",
  },
  {
    id: 18,
    imgSrc: "/assets/image/clean/18.jpg",
    title: "ASGC Construction L.L.C",
    description:
      "Duplicate site from Project 8; provided same services including regular office cleaning and pest control in high-occupancy commercial zones.",
  },
  {
    id: 19,
    imgSrc: "/assets/image/clean/19.jpg",
    title: "Rocky Real Estate L.L.C",
    description:
      "Apartment turnover cleaning and property pest control across managed residential units and retail properties under the company’s portfolio.",
  },
  {
    id: 20,
    imgSrc: "/assets/image/clean/6.jpg",
    title: "ABU DHABI INTERNATIONAL CONTRACTING & GENERAL .CO",
    description:
      "Delivered cleaning and pest prevention services for head office areas and surrounding facilities, ensuring a sanitized work environment.",
  },
];

export default projectData;
